import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendar,
  faArrowCircleUp,
} from "@fortawesome/free-solid-svg-icons";

const PaymentHistory = ({paymentHistory}) => {
    return (
      <div className="bg-white rounded-2xl p-6 shadow-md text-gray-900">
          <h3 className="text-xl font-bold mb-4 text-yellow-600">
            Payment Activity
          </h3>
          <div className="space-y-4">
            {paymentHistory.map((payment) => (
              <div
                key={payment.id}
                className="bg-gray-100 p-4 rounded-lg shadow-sm"
              >
                <div className="flex items-center justify-between">
                  <div>
                    <p className="font-semibold text-gray-800">
                      {payment.description}
                    </p>
                    <p className="text-sm text-gray-500">
                      <FontAwesomeIcon
                        icon={faCalendar}
                        className="mr-2 text-gray-500"
                      />
                      {payment.date}
                    </p>
                  </div>
                  <div className="flex items-center">
                    <FontAwesomeIcon
                      icon={faArrowCircleUp}
                      className="text-green-500 mr-2"
                    />
                    <span className="text-gray-800 font-semibold">
                      ₦{payment.amount.toFixed(2)}
                    </span>
                  </div>
                </div>
              </div>
            ))}
            {paymentHistory.length === 0 && (
              <p className="text-center text-gray-500">
                No payment records found.
              </p>
            )}
          </div>
        </div>
    );
}
 
export default PaymentHistory;